// @flow

/**
 * Export shadows.
 */

export const shadows = {
  medium: '0 30px 80px 0 rgba(46, 52, 56, .19), 0 12px 24px 0 rgba(46, 52, 56, .23)'
};



// WEBPACK FOOTER //
// ../src/client/styles/shadows.js